import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { projects, services } from '../utils/dataModel';
import SEO from './SEO';

const ProjectsListPage = () => {
  const groupedProjects = services.reduce((acc, service) => {
    acc[service.id] = {
      service,
      projects: service.project_ids.map(id => projects.find(p => p.id === id)).filter(Boolean)
    };
    return acc;
  }, {});

  // Reset scroll to top when component mounts or serviceId changes
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <SEO 
        title="All Projects | SolidlyAI"
        description="Explore all our client projects across Data & Analytics Engineering, Applied AI & Machine Learning, and Productization & Prototyping."
        type="website"
      />
      
      <div className="projects-list-page">
        <div className="projects-header">
          <div className="container">
            <div className="project-breadcrumb">
              <Link to="/">Home</Link>
              <span> / </span>
              <span>All Projects</span>
            </div>
            
            <div className="projects-header-content">
              <h1>Our Projects</h1>
              <p className="projects-subtitle">
                Explore our portfolio of successful client engagements across data engineering, 
                AI/ML, and product development.
              </p>
            </div>
          </div>
        </div>

        <div className="projects-content">
          <div className="container">
            {Object.entries(groupedProjects).map(([serviceId, { service, projects }]) => (
              <section key={serviceId} className="service-projects-section">
                <div className="service-section-header">
                  <Link to={`/services/${serviceId}`} className="service-title-link">
                    <h2>
                      <span className="service-icon">
                        <img 
                          src={service.image} 
                          alt={service.title}
                          className="service-image"
                        />
                      </span>
                      {service.title}
                    </h2>
                  </Link>
                  <p className="service-description">{service.description}</p>
                </div>
                
                <div className="projects-grid">
                  {projects.map((project) => (
                    <Link 
                      to={`/projects/${project.id}`} 
                      key={project.id} 
                      className="project-card-link"
                    >
                      <div className="project-card">
                        <div className="project-logo">
                          <img 
                            src={project.logo} 
                            alt={`${project.client_name} logo`}
                            onError={(e) => {
                              e.target.style.display = 'none';
                              e.target.nextSibling.style.display = 'block';
                            }}
                          />
                          <div className="project-icon" style={{display: 'none'}}>{project.icon}</div>
                        </div>
                        <h3>{project.title}</h3>
                        <p className="project-client">{project.client_name}</p>
                        <p className="project-summary">{project.problem_statement}</p>
                        <span className="project-link-text">View Project →</span>
                      </div>
                    </Link>
                  ))}
                </div>
              </section>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default ProjectsListPage;